var _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBcuLogoLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 217 435",
    style: {
      enableBackground: "new 0 0 217 435"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{clip-path:url(#SVGID_00000009549534667618066730000016082406999328905345_);fill:url(#SVGID_00000044899221102525736320000004336551246796590236_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -41,
    y: -51.9,
    width: 258.05,
    height: 495.79
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021102288531971514260000000099853984496835719_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011720886527324583360000004381353740674729351_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.104,
    y1: 217.5052,
    x2: 432.1411,
    y2: 217.5052
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002180233,
    style: {
      stopColor: "#009EE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DB828"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000021102288531971514260000000099853984496835719_)",
      fill: "url(#SVGID_00000011720886527324583360000004381353740674729351_)"
    },
    d: " M195.29,239.33c8.31,7.65,21.29,7.11,28.94-1.19l61.84-67.17c7.65-8.31,7.11-21.29-1.19-28.94l-0.55-0.51 c-4.01-3.69-9.23-5.59-14.71-5.37c-5.48,0.23-10.53,2.56-14.22,6.56l-61.85,67.16c-7.65,8.31-7.11,21.29,1.19,28.94L195.29,239.33z  M185.06,146.44l-0.55-0.5c-4.01-3.69-9.23-5.6-14.72-5.37c-5.48,0.23-10.53,2.56-14.22,6.56l-61.85,67.17 c-7.65,8.31-7.11,21.29,1.19,28.94l0.55,0.51c8.31,7.65,21.29,7.11,28.94-1.19l61.84-67.17 C193.9,167.07,193.37,154.09,185.06,146.44z M219.58,129.96c11.41-0.47,20.31-10.14,19.84-21.54 c-0.47-11.41-10.14-20.31-21.55-19.84c-11.41,0.47-20.31,10.14-19.84,21.54C198.51,121.53,208.17,130.43,219.58,129.96z  M160.22,255.3c-11.41,0.47-20.31,10.14-19.84,21.54c0.23,5.53,2.59,10.63,6.66,14.38c4.07,3.75,9.35,5.68,14.88,5.46 c11.41-0.47,20.31-10.14,19.84-21.54C181.29,263.72,171.63,254.82,160.22,255.3z M431.95,208.6 C427.04,89.53,326.18-3.34,207.11,1.57C88.04,6.48-4.83,107.34,0.08,226.41c4.91,119.07,105.77,211.94,224.84,207.03 C343.99,428.53,436.87,327.67,431.95,208.6z M223.89,408.33C118.67,412.67,29.54,330.6,25.2,225.38 C20.86,120.16,102.93,31.02,208.15,26.68c105.22-4.34,194.35,77.73,198.69,182.95C411.18,314.86,329.11,403.99,223.89,408.33z  M288.25,241.45c-4.01-3.69-9.23-5.6-14.71-5.37c-5.48,0.23-10.54,2.56-14.22,6.56l-61.84,67.16c-7.65,8.31-7.11,21.29,1.19,28.94 l0.55,0.51c8.31,7.65,21.29,7.11,28.94-1.19L290,270.9c7.65-8.31,7.11-21.29-1.19-28.94L288.25,241.45z M321.62,184.1 c-11.41,0.47-20.31,10.14-19.84,21.54c0.47,11.41,10.13,20.31,21.54,19.84c11.41-0.47,20.31-10.14,19.84-21.54 C342.69,192.53,333.03,183.63,321.62,184.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBcuLogoLeft);
export default __webpack_public_path__ + "static/media/bcu_logo_left.ae55e7b82ca5770a3177625b23784ccf.svg";
export { ForwardRef as ReactComponent };